import CrudRepository from './CrudRepository'

export default class FeedbackRepository extends CrudRepository {
  constructor () {
    super('feedback')
  }
}
